import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import {
  showSystemCohortError, showSystemCohort,
} from '../actions';
import actions from '../constants';
import SystemCohortService from '../services/systemCohortService';

function fetchSystemCohort(code) {
  return SystemCohortService.cohort(code)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

function* afterSystemCohortFetch(action, { response, error }) {
  if (error) {
    yield put(showSystemCohortError(action.category, action.code, error));
  } else {
    yield put(showSystemCohort(action.category, action.code, response, action.intl));
  }
}

export function* systemCohort(action) {
  const requestResponse = yield call(fetchSystemCohort, action.code);
  yield call(afterSystemCohortFetch, action, requestResponse);
}

export default function* systemCohortsApi() {
  yield takeEvery(actions.FETCH_SYSTEM_COHORT, systemCohort);
}
